<template>
  <div class="app-container">
    <list ref="list">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        </template>
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" @click="edit(row)" type="text" >
                      编辑
                    </el-button>
                    <el-button v-if="$permission.canReview()" type="text" @click="edit(row)">审核</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/productionpicking/list'


export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      api: require("@/api/pr/prGetDoc").default,
    }
  },
  methods: {
    create(){
      this.toURL({name:'editproductionpicking',params:{type:'create'}})
    },
   edit({DocId}){
      let id = DocId;
      this.api.info(id).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editproductionpicking',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }
      })
    },
    toURL(o){
      this.$router.push(o)
    }
  }
  
};
</script>